import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import LandingFooter from "../part/landing.footer";
import FooterRight from "../part/landing.footer.right";
import FloatingContact from "../part/floating.contact";
import LandingSearchHeader from "../part/header_search";
import LandingSearchContent from "./search_content";



const SearchParams = () => {
    const { prompt } = useParams();
    const navigate = useNavigate(); // Initialize useNavigate



    const handleSearch = (newPrompt) => {  // Function to update search term
        navigate(`/search/${newPrompt}`); // Navigate to the new search URL
    };

    return (
        <div className="body">
        
            <LandingSearchHeader onSearch={handleSearch} search={prompt}/>
            <div className="body search_contain">
            <LandingSearchContent search={prompt}/>
            </div>
            <FloatingContact />
            <LandingFooter />
            <FooterRight />
            
        </div>
    );
};

export default SearchParams;